import { render, staticRenderFns } from "./HomeV3.vue?vue&type=template&id=673b26a2&scoped=true"
import script from "./HomeV3.vue?vue&type=script&lang=js"
export * from "./HomeV3.vue?vue&type=script&lang=js"
import style0 from "./HomeV3.vue?vue&type=style&index=0&id=673b26a2&prod&lang=css"
import style1 from "./HomeV3.vue?vue&type=style&index=1&id=673b26a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b26a2",
  null
  
)

export default component.exports